import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'button']

  connect() {
    this.open = false
    this._boundHandleClickOutside = this.handleClickOutside.bind(this)
    this._boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.removeGlobalListeners()
  }

  toggle(event) {
    event.preventDefault()
    this.open = !this.open
    this.update()
  }

  handleClickOutside(event) {
    if (!this.open) return
    if (!this.element.contains(event.target)) {
      this.open = false
      this.update()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.open) {
      this.open = false
      this.update()
    }
  }

  update() {
    this.panelTarget.classList.toggle('hidden', !this.open)
    this.buttonTarget.setAttribute('aria-expanded', this.open ? 'true' : 'false')

    if (this.open) {
      this.addGlobalListeners()
    } else {
      this.removeGlobalListeners()
    }
  }

  addGlobalListeners() {
    document.addEventListener('click', this._boundHandleClickOutside)
    document.addEventListener('keydown', this._boundHandleKeydown)
  }

  removeGlobalListeners() {
    document.removeEventListener('click', this._boundHandleClickOutside)
    document.removeEventListener('keydown', this._boundHandleKeydown)
  }
}

